import formatText from "./format-text";

export default function setLocation(location) {
  return formatText(location);
}
